module.exports = __webpack_public_path__ + "img/star2.d4171523.png";